import { MATRIX_CLUB_SOFTWARE_NUMBERS } from '../../util/software-numbers';
import { useSoftwareNumber } from '../../state-management/selectors/use-software-number';
import { useUserType } from '../../state-management/selectors/use-user-type';

export function useMatrixCommercial(): boolean {
  const softwareNumber = useSoftwareNumber();
  const userType = useUserType();
  const isAnonymous = userType === 'anonymous';

  return isAnonymous && MATRIX_CLUB_SOFTWARE_NUMBERS.includes(Number.parseInt(softwareNumber, 10));
}
